function injectElementOnMobile() {
  const jciMobileGallaryContainer = document.querySelector('.product-form.off-card-container.sticky-content-container');
  const jciGallery = document.querySelector('.product_image_block_section')
  const jciBage = document.querySelectorAll('.product-label-container')
  const jciBageChild = document.querySelectorAll('.product-label-container .jci-custom-bage')

  window.jciBage = jciBage;

  // Fallback reveal of the buy column (the inline script in main-product normally does this while parsing).
  document.querySelectorAll('.jci-await-gallery').forEach(function (el) { el.classList.remove('jci-await-gallery'); });

  if (!jciMobileGallaryContainer || !jciGallery) return;
  // V2 templates already order gallery before title via CSS; moving the block only shifts the buy column (CLS).
  if (document.querySelector('.product-detail.jci-twin-v2')) return;

  if (window.innerWidth <= 767 ) {
    // console.log({jciGallery})
    // JCI EDITS - keep mobile PDP order as title/reviews, gallery, description, sale callout.
    const descriptionBlock = jciMobileGallaryContainer.querySelector('.prod-description-richtext');
    const fallbackChild = jciMobileGallaryContainer.children[4];
    jciMobileGallaryContainer.insertBefore(jciGallery, descriptionBlock || fallbackChild);
    // jciMobileGallaryContainer.innerHTML = jciGallery.innerHTML;
    //  jciGallery.remove();
    // jciBage.remove();
    if (jciBageChild.length > 1) {
      [...jciBageChild].forEach((el, idx, arr) => {
        if (idx !== arr.length - 2 && idx !== 1) el.remove(); // keep only the second-last
      });
    }
  }
}

function toggleDescription() {
  const description = document.querySelector('.product-info-block .jci-product-description');
  const seeMoreBtn = document.getElementById('seeMoreBtn');
  
  if (description.classList.contains('full-description')) {
    description.classList.remove('full-description');
    seeMoreBtn.textContent = 'See More';
  } else {
    description.classList.add('full-description');
    seeMoreBtn.textContent = 'See Less';
  }
}



window.addEventListener('DOMContentLoaded', injectElementOnMobile);
window.addEventListener('DOMContentLoaded', () => {
  const bageOfProductPage = document.querySelectorAll('.template-product .product-label-container');
  
  if (bageOfProductPage?.length > 0 ) {
    bageOfProductPage[bageOfProductPage?.length-1].remove()
  }
  // Delay a bit so MagicZoom can initialize first
  setTimeout(() => {
    const THUMB_SELECTOR = '.MagicToolboxSelectorsContainer .mz-thumb';
    const BADGE_SELECTOR = '.product-label-container .jci-custom-bage';
    // Update these if your arrows use different classes
    const NAV_SELECTOR = [
      '.mz-button.mz-button-next',
      '.mz-button.mz-button-prev',
      '.mz-next',
      '.mz-prev'
    ].join(', ');
    
    function updateBadges() {
      const thumbs = document.querySelectorAll(THUMB_SELECTOR);
      if (!thumbs.length) return;
      
      let idx = [...thumbs].findIndex(t => t.classList.contains('mz-thumb-selected'));
      if (idx < 0) idx = 0;
      
      const badges = document.querySelectorAll(BADGE_SELECTOR);
      badges.forEach((b, i) => {
        // Hide extra badges if the selected thumb is the 3rd or later
        b.style.display = (idx > 0 && i > 0) ? 'none' : '';
      });
    }
    
    // Click on thumbs OR next/prev arrows
    document.addEventListener('click', (e) => {
      if (e.target.closest(THUMB_SELECTOR) || e.target.closest(NAV_SELECTOR)) {
        // Defer until MagicZoom updates classes
        setTimeout(updateBadges, 0);
      }
    });
    
    // Optional: keyboard nav (left/right arrows)
    document.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        setTimeout(updateBadges, 0);
      }
    });

    // Fallback: observe class changes on thumbs (covers swipes/autoplay)
    const selectorsContainer = document.querySelector('.MagicToolboxSelectorsContainer');
    if (selectorsContainer && 'MutationObserver' in window) {
      const mo = new MutationObserver((mutations) => {
        if (mutations.some(m => m.type === 'attributes' && m.attributeName === 'class')) {
          updateBadges();
        }
      });
      mo.observe(selectorsContainer, { subtree: true, attributes: true, attributeFilter: ['class'] });
    }

    // Initial run
    updateBadges();

    // Keep your original opacity tweak
    document.querySelectorAll('.jci-custom-bage').forEach(el => {
      el.style.opacity = '1';
    });
  }, 1000);
});


window.addEventListener('resize', () => {
 
   injectElementOnMobile()

   
   if (window.innerWidth > 767) {
       const jciDesktopContainer = document.querySelector('.product-detail.quickbuy-content');
       const jciGallery = document.querySelector('.product_image_block_section')

    // Check if both elements exist
    if (jciDesktopContainer && jciGallery) {
      jciDesktopContainer.insertBefore(jciGallery, jciDesktopContainer.firstChild); // Insert as the first child
    }
  }

} );

// The back-in-stock app (Notify Me) appends its button to the end of the purchase
// form, below the eco banner on mobile. Keep it right under the add-to-cart button.
(function () {
  if (!document.querySelector('form.product-purchase-form')) return;
  function placeNotifyMe() {
    document.querySelectorAll('form.product-purchase-form .nm-portal').forEach(function (portal) {
      var button = portal.closest('form').querySelector('.quantity-submit-row__submit button[type="submit"]');
      if (button && button.nextElementSibling !== portal) button.insertAdjacentElement('afterend', portal);
    });
  }
  placeNotifyMe();
  new MutationObserver(placeNotifyMe).observe(document.body, { childList: true, subtree: true });
})();

// The native sticky bar is a static copy of the product section; the theme's inline
// sync only copies the chosen variant, so mirror the sold-out flag and the label too.
(function () {
  var main = document.querySelector('main#content .product-detail');
  var copy = document.querySelector('.sticky-add-to-cart .product-detail');
  if (!main || !copy) return;
  var mainButton = main.querySelector('.quantity-submit-row__submit button[type="submit"]');
  var copyButton = copy.querySelector('.quantity-submit-row__submit button[type="submit"]');
  function mirror() {
    copy.classList.toggle('variant-status--unavailable', main.classList.contains('variant-status--unavailable'));
    if (mainButton && copyButton && copyButton.textContent !== mainButton.textContent) copyButton.textContent = mainButton.textContent;
  }
  mirror();
  new MutationObserver(mirror).observe(main, { attributes: true, attributeFilter: ['class'] });
  if (mainButton) new MutationObserver(mirror).observe(mainButton, { childList: true, characterData: true, subtree: true });
})();

/* Klaviyo teaser: keep it glued to the top edge of a visible sticky add-to-cart bar.
   Updated every animation frame so it follows the bar's slide in/out exactly. */
(function () {
  var BARS = '.sticky-add-to-cart, .jci-twin-sticky, .sticky-cart-container, #md-sticky-atc';
  var teasers = [];
  var bars = [];
  var dirty = true;

  function refresh() {
    teasers = Array.prototype.slice.call(document.querySelectorAll('[class*="kl-teaser-"]'));
    bars = Array.prototype.slice.call(document.querySelectorAll(BARS));
    dirty = false;
  }

  function barOffset() {
    var offset = 0;
    bars.forEach(function (bar) {
      if (bar.hidden) return;
      var cs = window.getComputedStyle(bar);
      if (cs.display === 'none' || cs.visibility === 'hidden') return;
      var r = bar.getBoundingClientRect();
      if (r.height === 0 || r.top >= window.innerHeight - 1 || r.bottom < window.innerHeight - 2) return;
      offset = Math.max(offset, window.innerHeight - r.top);
    });
    return Math.round(offset);
  }

  function update() {
    if (dirty) refresh();
    if (!teasers.length || !bars.length) return;
    var px = barOffset() + 'px';
    teasers.forEach(function (teaser) {
      if (teaser.style.getPropertyValue('bottom') !== px) teaser.style.setProperty('bottom', px, 'important');
    });
  }

  function tick() {
    update();
    window.requestAnimationFrame(tick);
  }

  // Synchronous on DOM changes so a freshly inserted teaser is placed before its first paint. The interval covers throttled tabs.
  new MutationObserver(function () { dirty = true; update(); }).observe(document.documentElement, { childList: true, subtree: true });
  window.setInterval(update, 250);
  window.requestAnimationFrame(tick);
})();

/* BFCM date windows (CNV-6869): Shopify may serve a cached render around a switch-over, so every
   scheduled element also carries data-bfcm-start / data-bfcm-end (unix seconds) and is re-checked here.
   data-bfcm-toggle="hide" turns it around: hidden inside the window (the regular hero during the sale).
   QA: ?bfcm_now=2026-11-05T00:01-05:00 (or unix seconds) runs the check as if it were that moment. */
(function () {
  var q = new URLSearchParams(location.search).get('bfcm_now');
  var fake = q ? (/^\d+$/.test(q) ? q * 1000 : Date.parse(q)) : 0;
  var offset = fake ? fake - Date.now() : 0;
  function tick() {
    var now = (Date.now() + offset) / 1000;
    document.querySelectorAll('[data-bfcm-toggle]').forEach(function (el) {
      var start = +el.getAttribute('data-bfcm-start') || 0;
      var end = +el.getAttribute('data-bfcm-end') || 0;
      var outside = (start && now < start) || (end && now >= end);
      el.hidden = el.getAttribute('data-bfcm-toggle') === 'hide' ? !outside : outside;
    });
  }
  tick();
  window.setInterval(tick, 30000);
})();

/* Early access link (CNV-7071): Shopify's /discount/ link takes one code, the sale has two
   (strollers & wagons, accessories). ?discount=CODE1,CODE2 on any page adds them to the cart,
   keeping codes already there; Shopify checks each one and carries them to checkout. */
(function () {
  var codes = new URLSearchParams(location.search).get('discount');
  if (!codes) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  fetch(root + 'cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var all = (cart.discount_codes || []).map(function (d) { return d.code; });
      codes.split(',').forEach(function (c) {
        c = c.trim();
        if (c && all.indexOf(c) < 0) all.push(c);
      });
      return fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: all.join(',') })
      });
    })
    .then(function () { document.dispatchEvent(new CustomEvent('theme:cartchanged', { bubbles: true })); })
    .catch(function () {});
})();

/* Classic PDPs (V3): ticking an accessory adds it to the cart straight away, like the Add buttons on the
   Twin and Waggle (Kelsey 11/3). Those pages run their own handler in jci-twin-stroller-v2.js. */
document.addEventListener('change', function (event) {
  var input = event.target;
  if (!input.matches || !input.matches('.jci-addons-row input[type="checkbox"][name^="addon["]') || !input.checked) return;
  if (input.closest('.jci-twin-v2')) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  input.disabled = true;
  fetch(root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items: [{ id: Number(input.value), quantity: 1 }] })
  })
    .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message); }); })
    .then(function () { document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged', { bubbles: true, detail: { openDrawer: true } })); })
    .catch(function (error) { window.alert(error.message); })
    .then(function () {
      input.checked = false;
      input.disabled = false;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
});

/* Prices keep their cents (Katelin 11/3: $35 on cards vs $35.40 on the PDP). The shop format
   "${{amount_no_decimals}}" drops them, so prices with cents switch to the format with decimals and
   whole-dollar prices stay as they are ($449, $35.40), like the bfcm-money snippet. */
(function () {
  if (!window.theme || !theme.Shopify || !theme.Shopify.formatMoney) return;
  var formatMoney = theme.Shopify.formatMoney;
  theme.Shopify.formatMoney = function (cents, format) {
    var moneyFormat = format || this.money_format || theme.money_format || '';
    var value = typeof cents === 'string' ? parseInt(cents.replace('.', ''), 10) : Math.round(cents);
    if (moneyFormat.indexOf('amount_no_decimals') > -1 && value % 100 !== 0) {
      moneyFormat = moneyFormat.replace(/amount_no_decimals(?!_)/, 'amount');
    }
    return formatMoney.call(this, cents, moneyFormat);
  };
})();
